import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import { useDispatch } from 'react-redux';

const AnalyticsContextConsumer = MojitoCore.Presentation.AnalyticsContext.Context.Consumer;
const { RemoveButton } = MojitoPresentation.Components;
const { actions: betslipActions } = MojitoServices.Betslip;
const AnalyticsTypes = MojitoServices.Analytics.types;

const RemoveSelection = ({ bet, cbRemoveBet, selectionId, mojitoTools }) => {
    const { config } = mojitoTools;
    const dispatch = useDispatch();

    const removeSelection = analyticsPath => {
        return () => {
            dispatch(betslipActions.removeSelection({ selectionId, source: analyticsPath }));
        };
    };

    const removeBet = analyticsPath => {
        return () => {
            // Bet can be combined from multiple selections in case of multicast betting or match acca
            const betParts = bet.parts || [];
            const source = AnalyticsTypes.LEG_SORT_TO_SOURCE[bet.legSort] || analyticsPath;
            const selectionIds = betParts.map(part => part.selectionId);
            cbRemoveBet(selectionIds);
            dispatch(betslipActions.removeBet({ betId: bet.id, source }));
        };
    };

    const removeAction = analyticsPath =>
        selectionId ? removeSelection(analyticsPath) : removeBet(analyticsPath);

    if (config.hide) {
        return null;
    }

    return (
        <AnalyticsContextConsumer>
            {analyticsContext => (
                <RemoveButton
                    config={config.removeButton}
                    onClick={removeAction(analyticsContext.analyticsPath)}
                    class="ta-RemoveSelection"
                />
            )}
        </AnalyticsContextConsumer>
    );
};

export default RemoveSelection;
